import { Directive, HostListener, output } from '@angular/core';

@Directive({
  selector: '[etAtomsMenuItem]',
})
export class MenuItemDirective {
  clicked = output<void>();

  @HostListener('click')
  onClick(): void {
    this.clicked.emit();
  }
}
